import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para buscar os tipos de vaga de revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {UseQueryResult<any, unknown>} - Resultado da query.
 *
 * A resposta é um array de objetos.
 */
export function fetchRevendaTipoVaga({
  enabled,
  authToken,
}: {
  enabled?: boolean;
  authToken: string;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/RevendaTipoVaga";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.get(url, config);
    return response?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-revenda-tipo-vaga"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}
